import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { getAccountChangeLog } from '~/services/LuxLoyalty';

import { accountChangeLogQueryKeys } from './accountChangeLogQueryKeys';

/** One page (1-based) of a Société account's lifecycle changes, newest first. */
export function useGetAccountChangeLog(customerId: string, pagination: { page: number; pageSize: number }) {
  return useQuery({
    queryKey: accountChangeLogQueryKeys.page(customerId, pagination),
    queryFn: ({ signal }) => getAccountChangeLog(customerId, pagination, { signal }),
    placeholderData: keepPreviousData,
  });
}
